module.exports = __webpack_public_path__ + "static/media/one.6ed13aed.png";